import React, { Fragment } from 'react';
import './mandatoryFields.scss';

export default props => (
  <Fragment>
    <div className="clearfix"></div>
    <div className="box-mandatory-txt">Os campos com um * são obrigatórios</div>
  </Fragment>
);
